'use client';

import { c as _c } from "react/compiler-runtime";
import cx from 'classix';
import { useAtomValue } from 'jotai';
import { useTranslations } from 'next-intl';
import { isMapViewAtom } from '@/features/listing/atoms/is-map-view-atom';
import type { ListingType } from '@/features/listing/types/listing-types';
import { type ListingFaqItem } from '@/features/listing/types/listing-types';
import formatLocationName from '@/shared/utils/format-location-name';
import styles from './listing-faq.module.scss';
interface ListingFaqProps {
  questions: ListingFaqItem[];
  placeName: string;
  listingType: ListingType;
  location: string;
}
const FAQ_LOCATION_NAME_TITLE: Record<string, string> = {
  'new-york': 'New York City',
  'los-angeles': 'Los Angeles',
  'philadelphia': 'Philadelphia',
  'san-diego': 'San Diego',
  'las-vegas': 'Las Vegas, Nevada'
};
export default function ListingFaq(props) {
  const $ = _c(17);
  const {
    questions,
    placeName,
    listingType,
    location
  } = props;
  const translationsSeoFaq = useTranslations("seo.faq");
  const isMapView = useAtomValue(isMapViewAtom);
  let t0;
  if ($[0] !== listingType || $[1] !== location || $[2] !== placeName || $[3] !== translationsSeoFaq) {
    const titleLocation = formatLocationName(FAQ_LOCATION_NAME_TITLE[location] || placeName);
    const locationSpecificTitlePath = `title.locations.${location}.${listingType}`;
    const hasLocationSpecificTitle = translationsSeoFaq.has(locationSpecificTitlePath);
    t0 = hasLocationSpecificTitle ? translationsSeoFaq(locationSpecificTitlePath) : translationsSeoFaq(`title.${listingType}`, {
      placeName: titleLocation,
      location: titleLocation
    });
    $[0] = listingType;
    $[1] = location;
    $[2] = placeName;
    $[3] = translationsSeoFaq;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const title = t0;
  const t1 = isMapView && styles.listingFaq__isMapView;
  let t2;
  if ($[5] !== t1) {
    t2 = cx(styles.listingFaq, t1);
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== title) {
    t3 = <h2 className={styles.listingFaq_title}>{title}</h2>;
    $[7] = title;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== questions) {
    t4 = questions.map(_temp);
    $[9] = questions;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = <ul className={styles.listingFaq_list}>{t4}</ul>;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t2 || $[14] !== t3 || $[15] !== t5) {
    t6 = <div className={t2}>{t3}{t5}</div>;
    $[13] = t2;
    $[14] = t3;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}
function _temp(item) {
  return <li key={item.id} className={styles.listingFaq_item}><h3 className={styles.listingFaq_question}>{item.question}</h3><p className={styles.listingFaq_answer}>{item.answer}</p></li>;
}